import { Model, belongsTo } from 'miragejs';
import attr from 'ember-data/attr';

export default Model.extend({
  room: belongsTo('roomba/room'),

  appVersion: attr('string'),
  batteryLevel: attr('number'),
  bluetoothStatus: attr('string'),
  chargingStatus: attr('string'),
  clientId: attr('string'),
  displayName: attr('string'),
  jackStatus: attr('string'),
  ledAudioType: attr('string'),
  lightbarDetected: attr('boolean'),
  model: attr('string'),
  name: attr('string'),
  offlineAt: attr('date'),
  osVersion: attr('string'),
  status: attr('string'),
  volume: attr('number'),
});
